import { PlusIcon } from "@/components/Icons/PlusIcon";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/styles";
import { UserBalance } from "../UserBalance/UserBalance";
import { BalanceType } from "@/types/user";
import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { CreditsIcon } from "@/components/Icons/CreditsIcon";
import { useCallback, useState } from "react";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";
import env from "@/env";

type CreditsFieldProps = {
  className?: string;
  onPurchaseCredits?: () => void;
};

export const CreditsField = ({ className, onPurchaseCredits }: CreditsFieldProps) => {
  const [balance, setBalance] = useState<number>();
  const isLoggedIn = AuthMachineContext.useSelector((state) => state.context.isLoggedIn);
  const handleFetchBalance = useCallback((newBalance: number) => {
    setBalance(newBalance);
  }, []);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <>
      <div className={cn("flex flex-col gap-4 lg:flex-row", className)}>
        {
          <span
            className={cn(
              "flex flex-row items-center gap-3",
              typeof balance === "number" && balance > 0 ? "" : "hidden"
            )}
          >
            {/* <span className="text-sm text-gray">IO Credits Balance:</span> */}
            <CreditsIcon className="h-[8px]" />
            <UserBalance
              type={BalanceType.CREDITS}
              className="label-small"
              onFetchBalance={handleFetchBalance}
            />
          </span>
        }
        {!env.FEATUREFLAG_PURCHASE_CREDITS_ENABLED ? (
          <Button
            size="xs"
            variant="outline"
            className="gap-2"
            onClick={() => {
              trackEvent(AnalyticsEventType.REQUEST_CREDIT_CLICKED);
              onPurchaseCredits?.();
            }}
          >
            <PlusIcon className="h-[13px]" />
            <span>Request IO Credits</span>
          </Button>
        ) : (
          <Button
            size="xs"
            variant="outline"
            className="gap-2"
            onClick={() => {
              trackEvent(AnalyticsEventType.PURCHASE_CREDIT_CLICKED);
              onPurchaseCredits?.();
            }}
          >
            <PlusIcon className="h-[13px]" />
            <span>Purchase IO Credits</span>
          </Button>
        )}
      </div>
    </>
  );
};
